import { useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { useSelector } from 'react-redux';
import { getCurrentUserId, getToken } from '../../../../../app/auth/selectors';
import config from '../../../../../config';
import { getViewerIdAndKind, useSession } from '../../../../infra/session';
export var useChatSocket = function () {
    var userId = useSelector(getCurrentUserId);
    var jwtToken = useSelector(getToken);
    var session = useSession().data;
    var viewerIdAndKind = getViewerIdAndKind(session);
    var barberId = viewerIdAndKind === null || viewerIdAndKind === void 0 ? void 0 : viewerIdAndKind.id;
    var _a = useState(null), socket = _a[0], setSocket = _a[1];
    useEffect(function () {
        var newSocket = null;
        if (config.wsUrl) {
            newSocket = io(config.wsUrl, {
                transports: ['websocket'],
                auth: {
                    token: jwtToken,
                },
                query: {
                    barberId: barberId,
                },
            });
            setSocket(newSocket);
        }
        return function () {
            if (newSocket) {
                newSocket.disconnect();
                newSocket.removeAllListeners();
            }
        };
    }, [userId, jwtToken, barberId]);
    return { socket: socket };
};
